// Thank's IE8 for his funny defineProperty
module.exports = !!function(){
  try {
    return Object.defineProperty({}, 'a', {get: function(){ return 2; }}).a == 2;
  } catch(e){ /* empty */ }
}();


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.support-desc.js
 ** module id = 36
 ** module chunks = 0
 **/